export const DEFAULT_PDF_TEMPLATE_KEY = 'modern_corporate';

/** Common GST-style tax rate presets for product / line-item tax inputs. */
export const TAX_RATE_PRESETS = ['0', '5', '12', '18', '28'];

export const QUOTATION_TAB_IDS = {
  templates: 'templates',
  orders: 'orders',
};

export const QUOTATION_TABS = [
  { id: QUOTATION_TAB_IDS.templates, label: 'Quotation Templates' },
  { id: QUOTATION_TAB_IDS.orders, label: 'Customer Quotations' },
];

export const CUSTOMER_QUOTE_STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'generated', label: 'Generated' },
  { value: 'sent', label: 'Sent' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'expired', label: 'Expired' },
  { value: 'pending', label: 'Pending' },
  { value: 'draft', label: 'Draft' },
];

export const CUSTOMER_QUOTE_STATUS_TONE = {
  generated: 'neutral',
  sent: 'info', // Purple — Sent to WhatsApp
  accepted: 'success', // Green — Approved by client
  rejected: 'error', // Red   — Rejected by client
  expired: 'warning', // Amber — Past validity date
  pending: 'warning',
  draft: 'neutral',
  // Legacy uppercase keys — keep for backward compat with any old cached data
  SENT: 'info',
  PENDING: 'warning',
  DRAFT: 'neutral',
};

export const CUSTOMER_QUOTE_STATUS_LABEL = {
  generated: 'Generated',
  sent: 'Sent to WhatsApp',
  accepted: 'Accepted',
  rejected: 'Rejected',
  expired: 'Expired',
  pending: 'Pending',
  draft: 'Draft',
};

export const FIELD_LABEL_CLASS =
  'text-xs font-medium text-text-secondary font-sf-pro-display';

/** @deprecated Use FIELD_LABEL_CLASS */
export const DRAWER_LABEL_CLASS = FIELD_LABEL_CLASS;
